export const signatureItems = [
    { id: '0', name: 'Not Required'},
    { id: '1', name: 'Required'},
    { id: '3', name: 'Adult Signature Required'}
  ];